import {
  MediaInput,
  MediaType,
} from 'apps/shared/scripts/__generated__/graphql.generated';

import { MediaFormInput } from '../types';

const toMediaInput = (media: MediaFormInput): MediaInput => {
  return {
    extension: media.file!.type.split('/').pop(), // parse file extension
    src: '',
    type: MediaType.Image,
  };
};

export default toMediaInput;
